import CopyToClipboard from "../../copyToClipboard";
import UseContext from "../../../hooks/useContext";
import useSlideOver from "../../SlideOver/useSlideOver";
import { CheckIcon, NegativeThumb, PositiveThumb } from "../../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";
import useModal from "../../modal/useModal";
import { useEffect, useState } from "react";
import TableRow from "./TableRow";
import TableCell from "./TableCell";
import ClickableText from "./ClickableText";
import { getReviewLabel } from "../../card/ReviewCard";

const TbodyVivierRatingTempWorker = ({ champsBody }) => {
    const { setObjID } = UseContext();
    const { toggle } = useModal();
    const { toggleSlideOver } = useSlideOver();
    const location = useLocation();
    const navigate = useNavigate();
    const [selectedId, setSelectedId] = useState(null);

    const isUntreated = location.pathname.includes('rating-untreated');

    useEffect(() => {
        const id = new URLSearchParams(location.search).get('idRating');
        if (id) setSelectedId(id);
    }, [location.search]);

    const openCompanyInfo = (id) => {
        setObjID(id);
        toggleSlideOver('get_company');
    };

    const openModalRatingValidation = (id_rating) => {
        setObjID(id_rating);
        setSelectedId(id_rating);
        toggle('rating_temp_worker_validation');

        const params = new URLSearchParams(location.search);
        params.set('idRating', id_rating);
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    };

    const openTempWorkerInfo = (id) => {
        setObjID(id);
        toggleSlideOver('get_temp_worker');
    };

    return (
        <>
            {champsBody?.map((rating) => (
                <TableRow
                    key={rating?._id}
                    itemId={rating?._id}
                    selectedId={selectedId}
                    onClick={(id) => openModalRatingValidation(id)}
                    clickable={true}
                >
                    <TableCell position="first" stickyLeft={true} isSelected={selectedId === rating?._id}>
                        <div>
                            <CopyToClipboard text={`${rating?.user?.firstname} ${rating?.user?.lastname}`}>
                                <ClickableText
                                    onClick={(e) => { e.stopPropagation(); openTempWorkerInfo(rating?.user?._id); }}
                                    tooltipText="Voir le candidat"
                                >
                                    {rating?.user?.firstname} {rating?.user?.lastname}
                                </ClickableText>
                            </CopyToClipboard>
                        </div>
                        <div className="text-gray-500 mt-1">
                            <CopyToClipboard text={rating?.user?.email}>
                                <a className="underline" href={`mailto:${rating?.user?.email}`}>
                                    {rating?.user?.email}
                                </a>
                            </CopyToClipboard>
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className="text-gray-900">
                            {rating?.mission?.title} n°{rating?.mission?.id_mission}
                        </div>
                        <div className="text-gray-500 mt-1">
                            <ClickableText
                                onClick={(e) => { e.stopPropagation(); openCompanyInfo(rating?.id_company); }}
                                tooltipText="Voir l'entreprise"
                            >
                                {rating?.name_commercial}
                            </ClickableText>
                        </div>
                    </TableCell>
                    <TableCell>
                        <div className="flex gap-2 max-w-[250px] max-h-[100px] overflow-hidden">
                            <div className={`my-auto w-fit rounded-full p-2 ${rating.type === 'positive' ? 'bg-green-50' : 'bg-red-50'}`}>
                                {rating.type === 'positive'
                                    ? <PositiveThumb wh={24} color="#10B981" />
                                    : <NegativeThumb wh={24} color="#EF4444" />
                                }
                            </div>
                            <div className="my-auto flex-1 min-w-0">
                                <div className="text-gray-900">{getReviewLabel(rating)}</div>
                                <div className="text-gray-500 line-clamp-2">{rating?.comment}</div>
                            </div>
                        </div>
                    </TableCell>
                    <TableCell className={isUntreated ? '' : 'last'}>
                        <div className="text-gray-500 max-w-[250px] max-h-[100px] overflow-hidden">
                            {rating?.employee?.firstname} {rating?.employee?.lastname}
                        </div>
                    </TableCell>
                    {isUntreated && (
                        <TableCell position="last" hasButton buttonOnClick={() => openModalRatingValidation(rating?._id)} buttonContent={<CheckIcon w={24} h={12} color="#374151" />} />
                    )}
                </TableRow>
            ))}
        </>
    );
};

export default TbodyVivierRatingTempWorker;